import script from "./HolidaysCard.vue?vue&type=script&setup=true&lang=js"
export * from "./HolidaysCard.vue?vue&type=script&setup=true&lang=js"

import "./HolidaysCard.vue?vue&type=style&index=0&id=52134410&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52134410"]])

export default __exports__